import api from "./api";

// 从智能体的指定类型下移除文件夹
export async function removeAgentUserKnowledgeFolders({
  agentId,
  folderIds,
  type,
}: {
  agentId: string,
  folderIds: number[],
  type: string;
}) {
  const typeMap = { video: 1, podcast: 2, moments: 3, post: 4, article: 5 } as const;

  const res = await api.post<unknown>(`/knowledge/delete_agent_user_knowledge_folders_by_token`, {
    agent_id: agentId,
    folder_id: folderIds,
    type: typeMap[type],
  },);
  return res.data;
}
